<template>
	<o-card
		:selected="selected"
		class="candidate-card-agency"
		:class="{ 'candidate-card-agency--allways-show-actions' : setup.showActions }">
		<div class="candidate-card-agency__header">
			<o-avatar
				class="candidate-card-agency__avatar"
				size="sm"
				:name="tempWorker.name"
				:avatar="tempWorker.avatarId"
				root-url="/app/avatar/"/>

			<div class="candidate-card-agency__header-content">
				<p class="candidate-card-agency__user-name">{{ tempWorker.name }}</p>
				<p class="candidate-card-agency__user-city">{{ tempWorker.localisationString }}</p>
				<o-rate
					v-model="tempWorker.rating"
					font-icon="icon-interface-favorite-star-bold"
					disabled
					color="warning"
					:number-of-rates="tempWorker.numberOfRating"/>
			</div>

			<div
				v-tooltip="tempWorker.availability.tooltip"
				class="candidate-card-agency__availability"
				:class="[`candidate-card-agency__availability--${tempWorker.availability.color}`]"
				@click="setup.openTempWorkerAsideDetails('disponibility')">
				<div class="candidate-card-agency__availability-before"/>
				<o-icon font-icon="icon-interface-calendar-mark"/>
			</div>
		</div>

		<div class="candidate-card-agency__bubble-container">
			<div class="candidate-card-agency__bubble">
				<div class="candidate-card-agency__bubble-counter">
					{{ tempWorker.numberOfContracts }}
				</div>
				<div
					class="candidate-card-agency__bubble-icon"
					@click="tempWorker?.goToContracts()">
					<o-icon font-icon="icon-shopping-business-handshake"/>
				</div>
				<p class="candidate-card-agency__bubble-label">Contrats</p>
			</div>

			<div
				v-if="useCandidateService().inOrder()"
				class="candidate-card-agency__bubble">
				<div class="candidate-card-agency__bubble-counter">
					{{ tempWorker.numberOfContractsWithClient }}
				</div>
				<div
					class="candidate-card-agency__bubble-icon"
					@click="tempWorker?.goToContracts()">
					<o-icon font-icon="icon-shopping-business-handshake"/>
				</div>
				<p class="candidate-card-agency__bubble-label">Avec ce client</p>
			</div>

			<div class="candidate-card-agency__bubble">
				<div class="candidate-card-agency__bubble-counter">
					{{ tempWorker.userProfileCommentsCount }}
				</div>
				<div
					class="candidate-card-agency__bubble-icon"
					@click="setup.openTempWorkerAsideDetails(undefined, 'commentSection')">
					<o-icon font-icon="icon-interface-content-file"/>
				</div>
				<p class="candidate-card-agency__bubble-label">Commentaires</p>
			</div>

			<div class="candidate-card-agency__bubble">
				<div class="candidate-card-agency__bubble-counter">
					{{ tempWorker.userTasksCount }}
				</div>
				<div
					class="candidate-card-agency__bubble-icon"
					@click="setup.openTempWorkerAsideDetails(undefined, 'taskSection')">
					<o-icon font-icon="icon-interface-file-clipboard-check"/>
				</div>
				<p class="candidate-card-agency__bubble-label">Tâches</p>
			</div>
		</div>

		<div class="candidate-card-agency__main">
			<template v-if="tempWorker.profileIsPublic">
				<div class="candidate-card-agency__icon-section">
					<o-icon
						v-tooltip="`Qualifications`"
						font-icon="icon-programming-script-2"/>
					<div
						v-if="setup.skills().length"
						:ref="setup._skills"
						class="candidate-card-agency__chips-section">
						<o-chips
							v-for="(skill, index) in setup.skills()"
							:key="index"
							outline
							class="candidate-card-agency__chips">
							{{ skill.label }}
						</o-chips>
					</div>
					<div
						v-else
						class="candidate-card-agency__empty">
						Aucune qualification renseignée
					</div>
				</div>

				<div class="candidate-card-agency__icon-section">
					<o-icon
						v-tooltip="`Viviers`"
						font-icon="icon-interface-user-multiple"/>
					<div
						v-if="setup.talents().length"
						:ref="setup._talents"
						class="candidate-card-agency__chips-section">
						<o-chips
							v-for="(talent, index) in setup.talents()"
							:key="index"
							outline
							class="candidate-card-agency__chips">
							{{ talent.label }}
						</o-chips>
					</div>
					<div
						v-else
						class="candidate-card-agency__empty">
						N'appartient à aucun vivier
					</div>
				</div>

				<div class="candidate-card-agency__icon-section">
					<o-icon
						v-tooltip="`E-mail`"
						font-icon="icon-mail-inbox-envelope-open"/>
					<a
						v-if="tempWorker.authLogin"
						:href="`mailto:${tempWorker.authLogin}`">
						{{ tempWorker.authLogin }}
					</a>
					<div
						v-else
						class="candidate-card-agency__empty">
						Adresse mail non renseignée
					</div>
				</div>

				<div class="candidate-card-agency__icon-section">
					<o-icon
						v-tooltip="`Téléphone`"
						font-icon="icon-phone-mobile-phone"/>
					<a
						v-if="tempWorker.mobilePhone"
						:href="`tel:${tempWorker.mobilePhone}`">
						{{ tempWorker.mobilePhone }}
					</a>
					<div
						v-else
						class="candidate-card-agency__empty">
						Numéro de téléphone non renseigné
					</div>
				</div>
			</template>
			<o-alert
				v-else
				color="warning"
				center>
				L'interimaire ne partage pas son profil.<br>
				Ouvrez le détail pour en demander le partage.
			</o-alert>

			<div
				v-if="!useCandidateService().inOrder()"
				class="flex jc-c"
				style="margin-top:auto">
				<o-label
					v-if="tempWorker.isNotDemat"
					outline
					color="info">
					Non dématérialisé
				</o-label>
				<o-label
					v-else-if="tempWorker.isInactivated"
					outline
					color="warning">
					Utilisateur non activé
				</o-label>
				<o-label
					v-else-if="tempWorker.isActivated"
					outline
					color="success">
					Utilisateur activé
				</o-label>
				<o-label
					v-else-if="setup.self.isAgency() && tempWorker.hasToConfirmEmail"
					outline
					color="warning">
					Email non confirmé
				</o-label>
			</div>
		</div>

		<div
			v-if="useCandidateService().inOrder() && tempWorker.candidateStatus"
			class="candidate-card-agency__status">
			<o-label
				:color="tempWorker.candidateStatus.color"
				outline>
				{{ tempWorker.candidateStatus.label }}
			</o-label>
		</div>

		<template #actions>
			<o-icon
				v-if="setup.self.isAgency() && tempWorker.isInactivated"
				v-tooltip="`Renvoyer le mail d'activation`"
				ripple="info"
				font-icon="icon-phone-mobile-phone"
				:loading="tempWorker.sendingEmail"
				@click="tempWorker?.sendActivationMailAsync()"/>
			<o-icon
				v-if="setup.self.isAgency() && tempWorker.hasToConfirmEmail"
				v-tooltip="`Renvoyer le code de confirmation`"
				ripple="info"
				font-icon="icon-phone-mobile-phone"
				:loading="tempWorker.sendingEmail"
				@click="tempWorker?.sendEmailConfirmationAsync()"/>
			<o-icon
				v-if="!tempWorker?.isNotDemat"
				v-tooltip="`Voir le profil`"
				font-icon="icon-image-picture-portrait-view"
				ripple="info"
				@click="setup.openTempWorkerAsideDetails()"/>
			<!-- <o-icon
				v-if="useCandidateService().inOrder() && !setup.inModal"
				v-tooltip="`Discussion`"
				ripple="info"
				font-icon="icon-mail-chat-two-bubbles-square"
				@click="openDiscussionWithCandidate()"/> -->
			<o-icon
				v-if="setup.canSelectCandidat"
				v-tooltip="`Sélectionner cet intérimaire`"
				icon="check"
				ripple="info"
				@click="$emit('select')"/>
		</template>
	</o-card>
</template>

<script setup lang="ts">
import type OrderEntity from '@/entity/order/OrderEntity';
import useCandidateService from '@/services/CandidateService';
import TempWorkerCardSetupService from '@/setup/temp-worker/TempWorkerCardSetupService';
import { inject } from 'vue';
defineEmits(['select']);
const orderEntity = inject<OrderEntity>('OrderEntity');
const _modal = inject<OrionModal>('_modal');
const props = defineProps(TempWorkerCardSetupService.props);
const setup = new TempWorkerCardSetupService(props, _modal, orderEntity);
</script>

<style lang="less" scoped>
@import '@/styles/variables';
@import '@/styles/mixins';

.candidate-card-agency {
  p {
    margin: unset;
  }

  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 1.25rem;
  }

  &__header-content {
    display: block;
    overflow: hidden;
    max-width: 50%;
  }

  &__avatar {
    box-shadow: 0.125rem 0.125rem 0.45rem var(--grey-lighter);
    margin-right: 0.9rem;
  }

  &__user-name {
    .ellipsis();
    font-size: 1rem;
    font-weight: 600;
    color: var(--grey-darker);
  }

  &__user-city {
    font-size: 0.625rem;
    color: var(--grey-dark);
  }

  &__icon-section {
    display: flex;
    .orion-icon {
      margin-right: 0.94rem;
      font-size: 1.1rem;
      color: var(--grey);
    }
  }

  &__chips-section {
    display: flex;
    gap: 0.4rem;
    flex: 1;
    overflow: hidden;
  }

  &__chips {
    height: 1.3rem;
    font-size: 0.6rem;
    font-weight: 400;
    color: var(--grey-darker) !important;
    overflow: unset;
    text-transform: capitalize;
  }

  &__status {
    position: absolute;
    width: 100%;
    padding: 1.3rem;
    display: flex;
    justify-content: center;
    z-index: 2;
    left: 0;
    bottom: 0.6rem;
    border-radius: 0.6rem;
    transition: all 0.2s ease;

    body.istouch & {
      position: relative;
      bottom: auto;
      padding-bottom: 0;
    }
  }

  &__availability {
    position: absolute;
    top: 1.9rem;
    right: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--grey-lighter);
    border-radius: 50%;
    height: 2.5rem;
    width: 2.5rem;
    cursor: pointer;
    transition: box-shadow 0.2s;

    .orion-icon {
      font-size: 1.25rem;
      color: var(--grey);
    }

    &:hover {
      opacity: 0.7;
    }

    &::before {
      content: "";
      position: absolute;
      background: var(--grey-lighter);
      height: 2.2rem;
      width: 1.125rem;
      top: -1.9rem;
    }

    each(@colors, {
      @color: ~"--@{value}";
      @colorLight: ~"--@{value}-light";
      &--@{value} {
        background: var(@colorLight);
        .orion-icon {
          color: var(@color);
        }

        &::before {
          background: var(@colorLight);
        }
      }
    });
  }

  &__bubble-container {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 1.9rem;

    &::before {
      content: "";
      position: absolute;
      height: 0.06rem;
      width: calc(100% - 2.5rem);
      background: var(--grey-light);
      z-index: 0;
      top: calc(50% - 0.3rem);
    }
  }

  &__bubble {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__bubble-counter {
    position: relative;
    border: 0.13rem solid var(--grey-lighter);
    background: white;
    border-radius: 50%;
    width: 1.25rem;
    height: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--grey-dark);
    font-size: 0.625rem;
    margin-bottom: -0.625rem;
    z-index: 2;
  }

  &__bubble-icon {
    height: 3.1rem;
    width: 3.1rem;
    border-radius: 50%;
    background: var(--grey-lighter);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.3rem;
    transition: opacity 0.2s;
    border: 0.06rem solid var(--grey-lighter);
    cursor: pointer;
    transition: border-color 0.1s ease;

    &:hover {
      border: 0.06rem solid var(--info);

      .orion-icon {
        color: var(--info);
      }
    }

    .orion-icon {
      font-size: 1.25rem;
      color: var(--grey);
      transition: color 0.1s ease;
    }
  }

  &__bubble-label {
    text-align: center;
    color: var(--grey-dark);
    font-size: 0.625rem;
    line-height: 0.75rem;
  }

  &__main {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1.12rem;
  }

  &__icon-section {
    a {
      color: var(--info);
      font-size: 0.75rem;
    }
  }

  &__empty {
    font-size: 0.75rem;
    line-height: 0.94rem;
    font-style: italic;
    color: var(--grey-dark);
  }

  :deep(.orion-rate) {
    font-size: 0.8rem;
    margin-top: 0.2rem;

    &__star {
      font-size: 0.8rem;
    }
  }

  :deep(.orion-card__body) {
    display: flex;
    flex-direction: column;
  }

  body:not(.istouch) &:not(.candidate-card-agency--allways-show-actions) {
    .orion-card__actions {
      > .orion-icon {
        transition: opacity 0.3s, transform 0.2s;
        opacity: 0;
        transform: translate3d(30%, 0, 0);
      }

      > .div-action {
        transition: opacity 0.3s, transform 0.2s;
        display: flex;
        align-items: center;
        height: 2.5rem;
        margin: -0.625rem 0.625rem;
        margin-left: 1.18rem;
        opacity: 0;
        transform: translate3d(1.9rem, 0, 0);

        > .separator {
          //transition: opacity 0.3s, transform 0.2s;
          display: block;
          width: 0.06rem;
          height: 2.5rem;
          background: linear-gradient(
            to bottom,
            white 0%,
            var(--grey) 50%,
            white 100%
          );
          opacity: 0;
          transform: translate3d(1.25rem, 0, 0);
        }
      }
    }
  }

  body:not(.istouch) & {
    &:hover {
      .candidate-card-agency__status {
        opacity: 0;
        transform: translate3d(0, -100%, 0);
        z-index: -1;
      }

      .orion-card__actions > .orion-icon {
        opacity: 1;
        transform: translate3d(0, 0, 0);

       /*  each(range(5), {
					&:nth-child(@{value}) {
						transition-delay: calc(@value * 0.07s);
					}
				}); */
      }
    }
  }
}


</style>
